import { render, staticRenderFns } from "./DataGrid.vue?vue&type=template&id=0bd0ae1b&"
import script from "./DataGrid.vue?vue&type=script&lang=ts&"
export * from "./DataGrid.vue?vue&type=script&lang=ts&"
import style0 from "./DataGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports